import React, { useState } from "react";
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const CurrencyTextField = styled(TextField)({
  '& input': {
    textAlign: 'left',
  },
  '&.warning fieldset': {
    border: '1px solid #ed6c02',
  },
  '&.warning:hover fieldset': {
    border: '1px solid #ed6c02',
  },
});


const Main = ({ value, show_message }) => {
  const [has_warning, setHasWarning] = useState(false)

  const hasMoreThanTwoDecimalPlaces = (input) => {
    if(input) {
      return input.split('.')[1]?.length > 2
    } else {
      return false
    }
  }

  const needsWarning = () => {
    return has_warning || hasMoreThanTwoDecimalPlaces(value?.value)
  }

  return (
    <>
      <CurrencyTextField
        value={value?.value}
        // label="Subtotal"
        readOnly
        color={needsWarning() ? 'warning' : 'primary'}
        className={needsWarning() ? 'warning' : 'primary'}
        fullWidth
      />
      {show_message && <p>{value?.message}</p>}
    </>
  )
}

export default Main;
